<template>
    <div
            v-bind:class="{grayed: disabled}"
            class="component-container">
        <JobTypeSelectNode
                v-for="jobType in rootJobTypesOrdered"
                v-bind:key="jobType.id"
                v-bind:jobType="jobType"
                v-bind:selectedJobType="value"
                v-on:job-type-clicked="onJobTypeClicked">
        </JobTypeSelectNode>
        <div v-if="alertForOther" class="row">
            <div class="col-md-12">
                <div class="row alertOtherJobTypeBox">
                    <div class="col-md-12 alertOtherJobType">
                        <h5>ATTENTION</h5>
                        <p>La catégorie "Autre" ne doit être sélectionnée <span>QUE</span> si vous êtes certain que ce job ne correspond à aucune autre catégorie existante !</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import JobTypeSelectNode from './JobTypeSelectNode';
    import {JobType} from './JobType';

    export default {
        props: {
            rootJobTypes: Array,
            value: JobType,
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data(){
          return{
              numberOfClicks: 0,
              alertForOther: false
          }
        },
        methods: {
			onJobTypeClicked(jobType) {
                if (this.disabled === false) {
                    //Set number of click on the "Other" job type
                    if(jobType.isOther === true) {
                        this.numberOfClicks++;
                    } else {
                        this.numberOfClicks = 0;
                        this.alertForOther = false;
                    }

                    if (this.value !== null && this.value === jobType) {
                        this.numberOfClicks = 0;
                        if (jobType.isRoot() === null) {
                            this.$emit('input', null);
                        } else {
                            this.$emit('input', jobType.parent);
                        }
                    } else {
                        if(jobType.isOther === true && this.numberOfClicks < 2){ //Prevent the click and Display an alert DIV if is the first click on the "Other" Job Type
                            this.alertForOther = true;
                        } else {
                            this.alertForOther = false; //Hide the alert div
                            this.$emit('input', jobType);
                        }
                     }
                }
            }
        },
        computed: {
            rootJobTypesOrdered() {
                if (this.rootJobTypes === null) {
                    return null;
                }
                return this.rootJobTypes.sort((jobTypeA, jobTypeB) => jobTypeA.order > jobTypeB.order ? 1 : -1);
            }
        },
        components: {
            JobTypeSelectNode
        }
    }
</script>

<style scoped>
    .component-container {
        margin: 10px 0;
    }
    .grayed {
        filter: grayscale(100%);
        opacity: 0.7;
    }
    .alertOtherJobTypeBox{
        margin: 0;
    }
    .alertOtherJobType{
        background-color: rgb(242, 96, 60);
        text-align: center;
        margin-top: 15px;
        color: white;
    }
    .alertOtherJobType > h5{
        font-weight: bold;

    }
    .alertOtherJobType > p{
        font-size: 1.1em;
    }
    .alertOtherJobType > p > span{
        font-weight: bold;
        text-decoration: underline;
    }
</style>
